// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"4c3a61b8","187":"eea34faf","239":"edc2b42c","453":"366359a2","455":"d7c212f3","796":"e7cec7a1","906":"92586ec2","946":"b2ae6cdf"}[chunkId] + ".chunk.js";
};